import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Typography, Grid, Button } from "@mui/material";
import { Link } from "react-router-dom";
import { HandymanAppState } from "../../../../configuration/redux/reducers";
import { getUserReviews } from "../../../Reviews/actions";
import ReviewsList from "../../../../components/Reviews/ReviewsList";
import RatingSummary from "../../../../components/Reviews/RatingSummary";

interface UserReviewsProps {
  userId?: string;
}

const UserReviews: React.FC<UserReviewsProps> = ({ userId }) => {
  const dispatch = useDispatch();
  const { userReviews, userReviewsLoading, userReviewsError, userReviewsTotalCount } = useSelector(
    (state: HandymanAppState) => state.review
  );
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    if (userId) {
      dispatch(getUserReviews(userId, currentPage) as any);
    }
  }, [dispatch, userId, currentPage]);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h5">Reviews</Typography>
        <Button
          variant="outlined"
          color="primary"
          component={Link}
          to={`/reviews/user/${userId}`}
        >
          View All Reviews
        </Button>
      </Box>

      <Grid container spacing={4}>
        <Grid item xs={12} md={4}>
          <RatingSummary
            reviews={userReviews}
            loading={userReviewsLoading}
            totalCount={userReviewsTotalCount}
          />
        </Grid>
        <Grid item xs={12} md={8}>
          <ReviewsList
            reviews={userReviews.slice(0, 3)} // Show only first 3 reviews
            loading={userReviewsLoading}
            error={userReviewsError}
            totalCount={userReviewsTotalCount}
            onPageChange={handlePageChange}
            showActions={false}
            emptyMessage="No reviews yet"
            title=""
            currentPage={currentPage}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default UserReviews; 